export const adaptCreateQuickLinkPayload = (
	data: Partial<QuickLink>
): Partial<IQuickLink> => {
	return {
		heading: data.heading,
		content: data.content ?? null,
		button_link: data.buttonLink ?? null,
		webview: data.webview ?? false
	};
};

export const adaptEditQuickLinkPayload = (
	data: Partial<QuickLink>
): Partial<IQuickLink> => {
	return {
		id: data.id,
		heading: data.heading,
		content: data.content ?? null,
		button_link: data.buttonLink ?? null,
		webview: data.webview ?? false
	};
};
